var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"d-flex align-center justify-center fill-height"},[_c('Loader',{attrs:{"label":"Создание нового GSA"}})],1):_c('GsaCreator',{on:{"created":_vm.create_gsa}})}
var staticRenderFns = []

export { render, staticRenderFns }